




































import { Component, Vue, Watch } from 'vue-property-decorator'
import cbHikVideo from '@/components/hikVideo/index.vue'
import VideoList from './videos.vue'
import GroupList from './grouping.vue'
import RotationList from './rotation.vue'
import VideoRotationForm from '@/components/videoPlay/rotation.vue'
import VideoGroupForm from '@/components/videoPlay/group.vue'
import SearchVideoPoint from '@/components/videoPlay/selectPoints.vue'

import { namespace } from 'vuex-class'
import { newGuid } from '@/configs/functions'
const AppModule = namespace('app')

@Component({
  components: {
    cbHikVideo,
    VideoList, GroupList, RotationList,
    VideoGroupForm, SearchVideoPoint, VideoRotationForm
  }
})
export default class VideoPlay extends Vue {
  public tabName: string = 'list'
  @AppModule.Getter
  public sidebar!: { opened: boolean, withoutAnimation: boolean }

  public $refs!: {
    refHikVideo: any
    refVideoList: VideoList
    refGroupList: GroupList
    refRotationList: RotationList
  }

  public loadData() {
    const name = this.tabName
    this.$nextTick(() => {
      //视频列表，可以选择多个视频进行播放
      if (name == 'list') {
        if (this.$refs.refVideoList) {
          this.$refs.refVideoList.loadData()
        }
      }
      //视频分组
      else if (name == 'grouping') {
        if (this.$refs.refGroupList) {
          this.$refs.refGroupList.loadData()
        }
      }
      //视频分组
      else if (name == 'rotation') {
        if (this.$refs.refRotationList) {
          this.$refs.refRotationList.loadData()
        }
      }
    })
  }
  /** tab 切换，停止之前的播放。重新加载tab数据 */
  public tabClick(tab: any, event: any) {
    this.stopPlay()
    this.loadData()
  }

  /** 多选视频播放回传事件 */
  public videoPlays(codes: any[]) {
    this.stopPlay()
    this.multiPlay(codes)
  }

  /** 分组播放回传事件 */
  public groupPlays(group: { name: string, codes: any[] }) {
    this.stopPlay()
    this.playingMsg = '分组：' + group.name
    this.multiPlay(group.codes)
  }
  /**
   * 视频轮播逻辑
   * 轮播中有两组视频：A，B每组视频播放5分钟
   * 1.开始播放A，并设置5分钟后播放B
   * 2.5分钟后播放B，在设置5分钟后关闭B
   * 3.结束轮播组
   */
  public rotationPlayIndex: number = 0
  public rotationPlays(data: { name: string, min: number, groups: { name: string, codes: any[] }[] }) {
    this.stopPlay()
    this.rotationPlayIndex = 0
    this.loopPlay(data)
  }
  public loopTimer: any = null
  /** 轮播，循环播放不自动停止 */
  public loopPlay(data: { name: string, min: number, groups: { name: string, codes: any[] }[] }) {
    var groupCount = data.groups.length
    //判断视频索引是否小于视频数量
    //播放到最后一个视频的时候，重新从第一个开始放
    if (this.rotationPlayIndex >= groupCount) {
      this.rotationPlayIndex = 0
    }
    var timeOut = data.min * 1000 * 60//分钟
    var g = data.groups[this.rotationPlayIndex]
    this.playingMsg = '轮播组：' + data.name + '-' + g.name + ''
    // 播放视频
    this.multiPlay(g.codes)
    this.loopTimer = setTimeout(() => { this.loopPlay(data) }, timeOut)
    this.rotationPlayIndex++
  }
  /** 单次循环 放完自动停止*/
  public loopPlayOnce(data: { name: string, min: number, groups: { name: string, codes: string[] }[] }) {
    var groupCount = data.groups.length
    console.log('进入轮播' + this.rotationPlayIndex, groupCount)
    //判断视频索引是否小于视频数量
    //不是最后一个视频，就在10秒后继续播放
    if (this.rotationPlayIndex < groupCount) {
      var timeOut = 10000//测试用10秒 data.min * 1000 * 60//分钟
      var g = data.groups[this.rotationPlayIndex]
      this.playingMsg = '轮播组：' + data.name + '-' + g.name + ''
      // 播放视频
      this.multiPlay(g.codes)
      console.log('播放索引' + this.rotationPlayIndex, g)
      setTimeout(() => { this.loopPlay(data) }, timeOut)
      this.rotationPlayIndex++
    }
    else {
      //停止播放
      this.playingMsg = '轮播已结束'
      this.rotationPlayIndex = 0
      this.stopPlay()
      // console.log('轮播已结束', data)
    }
  }
  //多视频播放
  public multiPlay(codes: any[]) {
    //批量预览
    this.$refs.refHikVideo.startMulit(codes, true)
  }
  public clearTimer() {
    this.rotationPlayIndex = 0
    if (this.loopTimer) {
      clearTimeout(this.loopTimer)
    }
  }
  public stopPlay() {
    this.clearTimer()
    this.playingMsg = ''
    this.$refs.refHikVideo.stopAll()
  }
  //隐藏播放窗口
  public hideWnd() {
    this.$refs.refHikVideo.hideWnd()
  }
  //显示播放窗口
  public showWnd() {
    this.$refs.refHikVideo.showWnd()
  }

  public targetId: string = newGuid()
  public vWidth: number = 1000
  public vHeight: number = 600

  //#region 视频控件 相关代码
  public getWidth(): number {
    var dom = document.getElementById("videoContainer")
    var w = dom ? dom.offsetWidth : 860
    return w
  }
  public getHeight(): number {
    var h = document.documentElement.clientHeight - 200
    return h
  }
  public playingMsg: string = ''

  public loadCtrls() {
    this.$nextTick(() => {
      this.vWidth = this.getWidth()
      this.vHeight = this.getHeight()
      if (this.$refs.refHikVideo) {
        this.$refs.refHikVideo.initPlugin()
        //注销掉，重新调用
        window.onresize = null
        //页面大小变动时，重新加载控件
        window.onresize = () => {
          this.videoResize()
        }
        window.onscroll = null
        //页面大小变动时，重新加载控件
        window.onscroll = () => {
          this.videoResize()
        }
      }
    })
  }
  public videoResize() {
    if (this.$refs.refHikVideo) {
      let w = this.getWidth()
      let h = this.getHeight()
      this.$refs.refHikVideo.setResize(w, h)
    }
  }
  /** 监听数据变化 */
  @Watch('sidebar', { deep: true })
  SidebarWatch(data: any) {
    this.videoResize()
  }
  public beforeDestroy() {
    // this.stopPlay()
    this.$refs.refHikVideo.destroyPlugin()
    window.onresize = null
    window.onscroll = null
  }
  //#endregion

  public created() {
    if (this.targetId = '') {
      this.targetId = newGuid()
    }
  }
  public showVideoCtrl: boolean = true
  public mounted() {
    this.loadCtrls()
    this.loadData()
  }
  // 在当前路由改变，但是该组件被复用时调用
  @Watch('$route')
  public onRouteChange(route: any) {
    this.showVideoCtrl = false
    setTimeout(() => {
      this.showVideoCtrl = true
      this.loadCtrls()
    }, 500)
    //重置数据
    Object.assign(this.$data, this.$options.data)
  }
}
